import React from 'react';
import PropTypes from 'prop-types';
import GoogleMapReact from 'google-map-react';
import Marker from './Marker';
import DrupalHelper from '../../helper/DrupalHelper';
import { AppContext } from '../../context/AppContext';

class Map extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      bound: { center: null, zoom: null },
      items: [],
    }
  }

  componentDidMount() {
    this.setState({
      items: DrupalHelper.getData()
    })
  }

  getMarkers(legend) {
    let markers = [];

    Object.keys(this.state.items).forEach((country) => {
      Object.keys(this.state.items[country]).forEach((fellowship) => {
        const item = this.state.items[country][fellowship];
        let hidden = true;

        if (legend === 'all') {
          hidden = false;
        } else if (legend === 'USDISCA' && (fellowship === 'USDISCA' || fellowship === 'DISCA')) {
          hidden = false;
        } else if (legend === fellowship) {
          hidden = false;
        }

        markers.push(<Marker
          key={country + fellowship}
          hidden={hidden}
          lat={item.coordinate[1]}
          lng={item.coordinate[0]}
          icon={item.icon}
          entries={item.entries}
          legend={fellowship}
          country={country}
        />);
      });
    });

    return markers;
  }

  render() {
    const wrapper_style = Object.assign({}, DrupalHelper.getSetting('map_dimensions'));

    return <AppContext.Consumer>
      {({ legend, setLegend, legend_field }) => (
        <div className='map-wrapper' style={wrapper_style}>
          <GoogleMapReact
            bootstrapURLKeys={{ key: DrupalHelper.getSetting('gmap_api_key') }}
            defaultCenter={this.props.default_center}
            defaultZoom={this.props.default_zoom}
            center={this.state.bound.center || this.props.default_center}
            zoom={this.state.bound.zoom || this.props.default_zoom}>
            {this.getMarkers(legend)}
          </GoogleMapReact>
        </div>
      )}
    </AppContext.Consumer>
  }
}

Map.defaultProps = {
  default_center: { lat: 39.123989, lng: -97.287487 },
  default_zoom: 3,
};

Map.propTypes = {
  default_center: PropTypes.object,
  default_zoom: PropTypes.number,
};

export default Map;
